// extracted by mini-css-extract-plugin
export default {"animation":"AnimationPages_animation__bL5+N"};